import {freezeObjects} from 'src/utils'

export default {
  async created () {
    if (this.loadPageFunction) {
      await this.loadPageDataUsingGivenFunc()
    }
  },
  data () {
    return {
      serverSidePagination: {
        loadedPages: {},
        totalItems: 0,
        totalPages: 0
      }
    }
  },
  computed: {
    isServerSidePaginated () {
      return Boolean(this.loadPageFunction)
    }
  },
  methods: {
    async resetPagesAndReload () {
      this.serverSidePagination = {
        loadedPages: {},
        totalItems: 0,
        totalPages: 0
      }
      this.changePage(0)
    },
    async loadPageDataUsingGivenFunc () {
      if (this.serverSidePagination.loadedPages.hasOwnProperty(this.currentPage)) {
        return
      }

      this.state.loading = true

      const {items, totalItems, totalPages} = await this.loadPageFunction({
        perPage: this.mergedConfig.perPage,
        page: this.currentPage,
        orderBy: this.currentFieldSort.field || this.mergedConfig.defaultSortField,
        search: this.search[this.lastSearchedField || this.mergedConfig.defaultColumnSearch],
        searchedField: this.lastSearchedField || this.mergedConfig.defaultColumnSearch,
        reverse: this.currentFieldSort.order === 'desc',
        allSearch: this.search
      })

      if (!items?.length) return

      this.serverSidePagination.totalPages = totalPages
      this.serverSidePagination.totalItems = totalItems
      this.serverSidePagination.loadedPages = {
        ...this.serverSidePagination.loadedPages,
        [this.currentPage]: [...freezeObjects(items)]
      }

      this.state.loading = false
    }
  }
}
